/**
 *  Italy specific form validation rules
 */
export const isPhoneNumber = (value: string): boolean => {
  return REGEX.PHONE_NUMBER.test(value)
}

export const isPhoneNumberForAAB = (value: string): boolean => {
  return REGEX.MOBILE_PHONE_NUMBER_AAB_ONLY.test(value)
}

export const isMobilePhoneNumber = (value: string): boolean => {
  return REGEX.MOBILE_PHONE_NUMBER.test(value)
}

export const isPostalCode = (value: string): boolean => {
  return REGEX.POSTAL_CODE.test(value)
}

const REGEX = {
  MOBILE_PHONE_NUMBER: /^[0-9]{8}$/,
  MOBILE_PHONE_NUMBER_AAB_ONLY: /^\+?[0-9]{8,12}$/,
  PHONE_NUMBER: /^[0-9]{6,12}$/,
  POSTAL_CODE: /^\d{3}[ ]?\d{2}$/,
}
